/**
 * ResultActions - CTA buttons on result page
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LEVEL_LABELS } from '@/lib/api';
import ShareButtons from '@/components/ShareButtons';
import { Share2, Briefcase, ArrowRight, Repeat, ChevronUp } from 'lucide-react';

export default function ResultActions({ 
  runId, 
  level, 
  result,
  nextLevel, 
  isUnlocked, 
  isFinalScreen 
}) {
  const navigate = useNavigate();
  const [showShare, setShowShare] = useState(false);

  return (
    <div className="grid gap-2 sm:gap-3">
      {nextLevel && isUnlocked && (
        <Button
          onClick={() => navigate('/quiz/intro', { state: { level: nextLevel } })}
          className="w-full h-10 sm:h-12 bg-[#3B82F6] hover:bg-[#2563EB] text-white font-outfit font-bold text-sm sm:text-base rounded-xl"
          data-testid="next-level-btn"
        >
          {LEVEL_LABELS[nextLevel]} spielen <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      )}
      
      {/* Challenge Button + Share Buttons */}
      <Button
        onClick={() => setShowShare(!showShare)}
        variant="outline"
        className={`w-full h-10 sm:h-12 border-[#8B5CF6]/40 text-[#A78BFA] hover:bg-[#8B5CF6]/10 font-outfit font-bold text-sm sm:text-base rounded-xl ${showShare ? 'bg-[#8B5CF6]/10' : ''}`}
        data-testid="challenge-friend-btn"
      >
        <Share2 className="w-4 h-4 mr-2" /> 
        Freund herausfordern
        {showShare && <ChevronUp className="w-4 h-4 ml-2" />}
      </Button>
      
      {showShare && (
        <ShareButtons runId={runId} level={level} />
      )}

      <Button
        onClick={() => navigate('/apply/type', { state: { runId, result } })}
        variant="outline"
        className="w-full h-10 sm:h-12 border-[#10B981]/40 text-[#10B981] hover:bg-[#10B981]/10 font-outfit font-bold text-sm sm:text-base rounded-xl"
        data-testid="apply-btn"
      >
        <Briefcase className="w-4 h-4 mr-2" /> Bewerben
      </Button>
      
      {isFinalScreen && (
        <Button
          onClick={() => navigate('/quiz/intro', { state: { level } })}
          variant="ghost"
          className="w-full h-9 sm:h-auto text-[#9CA3AF] hover:text-white text-sm"
          data-testid="replay-level-btn"
        >
          <Repeat className="w-4 h-4 mr-2" /> {LEVEL_LABELS[level]} nochmal spielen
        </Button>
      )}
      
      <Button
        onClick={() => navigate('/')}
        variant="ghost"
        className="w-full h-9 sm:h-auto text-[#9CA3AF] hover:text-white text-sm"
        data-testid="back-home-btn"
      >
        Zurück zur Startseite
      </Button>
    </div>
  );
}
